<div class="image"><ng-content select="[image]"></ng-content></div>

<div class="text">
  <div class="top">
    <ng-content select="[top]"></ng-content>
  </div>
  <div class="bottom">
    <ng-content select="[bottom]"></ng-content>
  </div>
</div>
